import React from 'react';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { TextField, FormControl } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import FormErrorMessage from '../Errormessage';

const TimePickerComponent = ({
    error,
    messages,
    control,
    label,
    name,
    className,
    minTime,
    maxTime,
    ...rest
}) => {

    return (
        <FormControl className={className}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                    name={name}
                    control={control}
                    rules={{ 
                        required: messages?.required,
                        validate: rest.validate,
                     }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                        <TimePicker
                            label={label}
                           value={value ? dayjs(value, 'HH:mm') : null}
                            onChange={(time) =>
                                onChange(time ? dayjs(time).format('HH:mm A') : null)
                            }
                            minTime={minTime ? dayjs(minTime, 'HH:mm A') : undefined}
                            maxTime={maxTime ? dayjs(maxTime, 'HH:mm A') : undefined}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputRef={ref}
                                    onBlur={onBlur}
                                    error={!!error}
                                    helperText={error?.message}
                                />
                            )}
                            {...rest}
                        />
                    )}
                />
            </LocalizationProvider>
            <div>
                <FormErrorMessage error={error} messages={error?.message} />
            </div>
        </FormControl>
    );
};

export default TimePickerComponent;
